<template>
  <div class="welcome-card">
    <div class="welcome-card__content">
      <div class="welcome-card__content--title">{{ title }}</div>
      <div class="welcome-card__content--text">Outfox AI is the easiest way to fundraise and get your message out to your supporters!</div>
      <div class="welcome-card__content--subtitle">Would you like to create an:</div>
    </div>
    <div class="welcome-card__action">
      <button class="ou-btn ou-btn--large ou-btn--aqua" v-ripple @click="nextPage(true)">
        <span>ECOMMERCE</span>
      </button>
      <button class="ou-btn ou-btn--large ou-btn--cerulean" v-ripple @click="nextPage(false)">
        <span>POLITICAL CAMPAIGN</span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TheWelcomeFirstPage',
    props: {
      title: {
        type: String,
        default: 'Welcome to Outfox AI'
      }
    },
    methods: {
      nextPage (agency) {
        this.$emit('showAgencyForm', agency)
      }
    }
  }
</script>
<style lang="scss">
  $background-card: rgb(225, 115, 101);
  $color-title: rgb(255, 255, 255);
  $color-text: rgb(250, 251, 252);

  .welcome-card {
    position: relative;
    width: 100%;
    max-width: 800px;
    height: auto;
    background: $background-card;
    &__content {
      width: 100%;
      padding: 24pt;
      text-align: center;
      &--title {
        padding-bottom: 1.5rem;
        font-size:  3.7vmax;
        font-weight: bolder;
        color: $color-title;
      }
      &--text {
        width: 100%;
        max-width: 470px;
        margin: 0 auto;
        padding-bottom: 1.5rem;
        font-size: 1.5rem;
        font-weight: 500;
        color: $color-text;
      }
      &--subtitle {
        font-size: 1.7rem;
        font-weight: bold;
        color: $color-title;
      }
    }
    &__action {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: stretch;
      margin-bottom: -60px;
      .ou-btn {
        margin: 1rem;
      }
    }
    &::before {
      content: url("../../assets/img/stars.svg");
      position: absolute;
      width: 70px;
      height: 70px;
      left: 20px;
      top: -33px;
    }
    &::after {
      content: url("../../assets/img/rocket.svg");
      position: absolute;
      width: 200px;
      height: 200px;
      right: -80px;
      bottom: -60px;
    }
  }
  @media screen and (max-width: 960px) {
    .welcome-card {
      &__content {
        &--text,
        &--subtitle {
          font-size: 1rem;
        }
      }
      &__action {
        flex-direction: column;
        justify-content: stretch;
        .ou-btn {
          width: auto;
        }
      }
      &::before {
        width: 40px;
        height: 40px;
      }
      &::after {
        top: -80px;
        right: 10px;
        width: 100px;
        height: 100px;
      }
    }

  }
</style>
